<div class="dialog" id="successModal" data-type="simple" [dir]="textDir">
  <div class="content">
    <div class="top" [dir]="textDir">              
      <div class="left"> 
        <div>
          <img src="assets/images/success3x.png" width="28" height="28" align="middle">
        </div>
        <div class="title marT5" [ngClass]="textDir=='ltr'?'padL15':'padR15'">{{this.titleMessage | translate}}</div>             
      </div>
    </div>
    <div class="body" [ngClass]="textDir=='ltr'?'padR30':''" [dir]="textDir">
      <div *ngIf="this.subTitleMessage"> {{this.subTitleMessage | translate}}</div>  
      <div *ngIf="this.listMessage" [ngClass]="this.subTitleMessage?'marT15':''"> 
        <ul class="" [ngClass]="textDir=='ltr'?'padL15':'padR15'">
          <li class="no-pad" *ngFor="let item of this.listMessage">
            {{item.name | translate}}
          </li>
        </ul>
      </div> 
       <div class="marT15" *ngIf="this.detailMessage"> {{this.detailMessage | translate}}</div>  
       <div class="marT15" *ngIf="this.detailMessageLine1"> {{this.detailMessageLine1 | translate}}</div>
       <div class="marT15" *ngIf="this.detailMessageLine2"> {{this.detailMessageLine2 | translate}}</div>    
    </div>
    <div class="bottom" [dir]="textDir">
      <button class="btn primary" [ngClass]="textDir=='ltr'?'pull-right':'pull-left'" data-close="true">{{'Ok' | translate}}</button>
    </div>
  </div>
</div>
